// extracted by mini-css-extract-plugin
export default {"Copyrights":"jNtA0","left":"xsdTm"};